import { useMemo } from 'react';
import { Chip, Stack } from '@mui/material';

export type FilterChipOption = {
  value: string;
  label: string;
};

export interface FilterChipsProps {
  options: FilterChipOption[];
  value: string;
  onChange: (value: string) => void;
}

const FilterChips: React.FC<FilterChipsProps> = ({
  options,
  value,
  onChange,
}) => {
  const chips = useMemo(
    () => [{ value: '', label: 'All' }, ...options],
    [options]
  );

  return (
    <Stack
      direction="row"
      spacing={1}
      useFlexGap
      flexWrap="wrap"
      sx={{ mb: 1.5, flexShrink: 0 }}
    >
      {chips.map((option) => (
        <Chip
          key={option.value || 'all'}
          label={option.label}
          size="small"
          color={value === option.value ? 'primary' : 'default'}
          variant={value === option.value ? 'filled' : 'outlined'}
          onClick={() => onChange(option.value)}
        />
      ))}
    </Stack>
  );
};

export default FilterChips;
